import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Crater1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CRATER1;
}

export default Crater1PoiTileEntity;
